// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { ArrowRightSvg } from '../../assets/svg';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

const MoreBetsButtonWrapper = styled.div`
  position: relative;
  padding: 0.3em;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: ${theme.MatchCardMoreBetsButton.normal.backgroundColor};
  transition: all 150ms ease-in-out;
  &:active {
    background-color: ${theme.MatchCardMoreBetsButton.active.backgroundColor};
    & svg {
      transform: translateX(0.1em);
    }
  }
  cursor: pointer;
`;

const MoreBetsButtonValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 0.2em;
`;

const spacing = 0.5;

const MoreBetsButtonValue = styled.div`
  color: ${theme.MatchCardMoreBetsButton.normal.valueColor};
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: -${spacing / 2}em;
`;

const MoreBetsButtonValueLabel = styled.div`
  color: ${theme.MatchCardMoreBetsButton.normal.valueLabelColor};
  font-size: 0.8em;
  margin-top: -${spacing / 2}em;
`;

const MoreBetsButtonArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ArrowRight = styled(ArrowRightSvg)`
  height: 1.4em;
  width: 0.5em;
  transition: all 150ms ease-in-out;
`;

type MatchCardMoreBetsButtonProps = {
  moreBets: number;
  onClick?: () => void;
  className?: string;
};

const MatchCardMoreBetsButton = ({ className, moreBets, onClick = () => {} }: MatchCardMoreBetsButtonProps) => {
  if (moreBets) {
    return moreBets ? (
      <MoreBetsButtonWrapper className={className} onClick={onClick}>
        <MoreBetsButtonValueWrapper>
          <MoreBetsButtonValue>{moreBets}</MoreBetsButtonValue>
          <MoreBetsButtonValueLabel>{__('!short:bet', moreBets, '!short:bets')}</MoreBetsButtonValueLabel>
        </MoreBetsButtonValueWrapper>
        <MoreBetsButtonArrowWrapper>
          <ArrowRight />
        </MoreBetsButtonArrowWrapper>
      </MoreBetsButtonWrapper>
    ) : null;
  }

  return null;
};

export default MatchCardMoreBetsButton;
